import { c as _c } from "react/compiler-runtime";
import { getAvatarUrl } from 'shared/components/header/utils/get-avatar-url';
import { useDashboardUser } from './hooks/use-dashboard-user';
import { usePublicUser } from './hooks/use-public-user';
import { useUserStatus } from './hooks/use-user-status';
import { useUserSubaccounts } from './hooks/use-user-subaccounts';
const useUser = () => {
  const $ = _c(32);
  const {
    publicUser,
    publicMutate
  } = usePublicUser();
  const {
    dashboardUser,
    dashboardMutate,
    isDisabled
  } = useDashboardUser();
  const user = !isDisabled ? dashboardUser : undefined;
  let t0;
  if ($[0] !== dashboardUser) {
    t0 = getAvatarUrl(dashboardUser);
    $[0] = dashboardUser;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const avatarUrl = t0;
  const {
    isWsAdmin,
    checkAdminRoles,
    checkImpersonatorAdminRoles,
    isWorkspaceOwner,
    isAffiliate,
    isCustomer,
    isStudent,
    isWsAssistant,
    isRootAdmin,
    isWhiteLabelOwner,
    isSupportImpersonation,
    isSubAccountImpersonation,
    intlLocale,
    isRestrictedUser,
    isFreemium,
    isPaid
  } = useUserStatus(user);
  let t1;
  if ($[2] !== dashboardUser || $[3] !== isSupportImpersonation) {
    t1 = {
      dashboardUser,
      isSupportImpersonation
    };
    $[2] = dashboardUser;
    $[3] = isSupportImpersonation;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    subAccountsData,
    changeSubAccount
  } = useUserSubaccounts(t1);
  const t2 = !dashboardUser && !publicUser;
  let t3;
  if ($[5] !== avatarUrl || $[6] !== changeSubAccount || $[7] !== checkAdminRoles || $[8] !== checkImpersonatorAdminRoles || $[9] !== dashboardMutate || $[10] !== dashboardUser || $[11] !== intlLocale || $[12] !== isAffiliate || $[13] !== isCustomer || $[14] !== isDisabled || $[15] !== isFreemium || $[16] !== isPaid || $[17] !== isRestrictedUser || $[18] !== isRootAdmin || $[19] !== isStudent || $[20] !== isSubAccountImpersonation || $[21] !== isSupportImpersonation || $[22] !== isWhiteLabelOwner || $[23] !== isWorkspaceOwner || $[24] !== isWsAdmin || $[25] !== isWsAssistant || $[26] !== publicMutate || $[27] !== publicUser || $[28] !== subAccountsData || $[29] !== t2 || $[30] !== user) {
    t3 = {
      user,
      publicUser,
      dashboardUser,
      mutate: dashboardMutate,
      mutatePublic: publicMutate,
      isCustomer,
      isAffiliate,
      isStudent,
      checkAdminRoles,
      checkImpersonatorAdminRoles,
      isWorkspaceOwner,
      isWsAdmin,
      isWsAssistant,
      isLoading: t2,
      isDisabled,
      isRootAdmin,
      isWhiteLabelOwner,
      isSubAccountImpersonation,
      isSupportImpersonation,
      intlLocale,
      subAccountsData,
      changeSubAccount,
      isRestrictedUser,
      avatarUrl,
      isFreemium,
      isPaid
    };
    $[5] = avatarUrl;
    $[6] = changeSubAccount;
    $[7] = checkAdminRoles;
    $[8] = checkImpersonatorAdminRoles;
    $[9] = dashboardMutate;
    $[10] = dashboardUser;
    $[11] = intlLocale;
    $[12] = isAffiliate;
    $[13] = isCustomer;
    $[14] = isDisabled;
    $[15] = isFreemium;
    $[16] = isPaid;
    $[17] = isRestrictedUser;
    $[18] = isRootAdmin;
    $[19] = isStudent;
    $[20] = isSubAccountImpersonation;
    $[21] = isSupportImpersonation;
    $[22] = isWhiteLabelOwner;
    $[23] = isWorkspaceOwner;
    $[24] = isWsAdmin;
    $[25] = isWsAssistant;
    $[26] = publicMutate;
    $[27] = publicUser;
    $[28] = subAccountsData;
    $[29] = t2;
    $[30] = user;
    $[31] = t3;
  } else {
    t3 = $[31];
  }
  return t3;
};
export default useUser;